import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth/AuthContext";
import { FullPageSpinner } from "@/components/ui";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth();

  switch (state.status) {
    case "loading":
      return <FullPageSpinner label="Comprobando sesion" />;
    case "authenticated":
      return <>{children}</>;
    case "session_expired":
      return <Navigate to="/session-expired" replace />;
    case "totp_challenge":
      return <Navigate to="/login/totp" replace />;
    case "unauthenticated":
    default:
      return <Navigate to="/login" replace />;
  }
}
